import Icon from "../comps/Icon.vue"

export default {
    install: (app :any) => {
        app.component("icon", Icon)
    }
}